import { Skeleton } from '@/components/ui/skeleton';

const ROWS = 6;

export function ProjectAnalysisListLoading() {
  return (
    <div className="rounded-md border border-slate-200 overflow-hidden">
      <div className="flex gap-3 border-b border-slate-200 bg-slate-50/80 p-3">
        <Skeleton className="h-5 flex-1 min-w-0" />
        <Skeleton className="h-5 flex-1 min-w-0" />
        <Skeleton className="h-5 w-[140px] shrink-0" />
        <Skeleton className="h-9 w-[88px] shrink-0" />
      </div>
      {Array.from({ length: ROWS }).map((_, i) => (
        <div
          key={i}
          className="flex gap-3 items-center border-b border-slate-100 p-3 last:border-b-0"
        >
          <Skeleton className="h-5 flex-1 min-w-0" />
          <Skeleton className="h-5 flex-1 min-w-0" />
          <Skeleton className="h-5 w-[140px] shrink-0" />
          <Skeleton className="h-9 w-[88px] shrink-0 rounded-md" />
        </div>
      ))}
    </div>
  );
}
